<router-outlet></router-outlet>
<ng-http-loader [backgroundColor]="'rgb(224, 23, 40)'" spinner="sk-three-bounce" [debounceDelay]="1000"
    [minDuration]="300" [extraDuration]="300"
    [filteredUrlPatterns]="['/assets/images/', 'excel/download-managers-teams-update', 'excel/upload-managers-teams-update']">
</ng-http-loader>
<p-toast [position]="position" [ngStyle]="{'z-index': '1102'}"/>
<pp-probation-notifications/>
